<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>Terms & Condition</h2> -->
                    <h2>
                        <li class="breadcrumb-item">
                            <a [routerLink]="['/']" routerLinkActive="router-link-active"><i
                class="fa-solid fa-house"></i></a>
                        </li>
                        <li class="breadcrumb-item active">Shipping & Delivery Policy</li>
                    </h2>
                    <nav>
                        <ol class="breadcrumb mb-0">
                            <img src="assets/images/logo/logo.png" [routerLink]="['/']" routerLinkActive="router-link-active" class="logosize" alt>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->

<!-- Fresh Vegetable Section Start -->
<section class="fresh-vegetable-section section-lg-space">
    <div class="container-fluid-lg">
        <div class="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div class="svr_main_wrap">
                <div class="svr_content_wrap">
                    <h2><span style="color: rgb(68, 68, 68);">Shipping & Delivery Policy</span></h2>
                    <br />
                    <p><span style="color: rgb(68, 68, 68);">For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 6-8 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. SRIVARI SUPPLY CHAIN PRIVATE LIMITED is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 6-8 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on 9121212020 or {{ email }}</span></p>


                    <br/>

                </div>
            </div>
        </div>
    </div>
</section>
